var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404PageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 375,
    viewBox: "0 0 607 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.3 297L119.3 291H125.3V297Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3821 258.648V222.32L111.469 78.8182H142.79V129.102H124.253L66.831 219.976V221.68H196.27V258.648H20.3821ZM125.105 297V247.568L125.957 231.482V78.8182H169.21V297H125.105Z",
    fill: "#006BD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3821 252.648V216.32L105.469 72.8182H136.79V123.102H118.253L60.831 213.976V215.68H190.27V252.648H14.3821ZM119.105 291V241.568L119.957 225.482V72.8182H163.21V291H119.105Z",
    fill: "#007FFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 258.6L14.5 252.6H20.5V258.6Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.3 215.8L196.3 221.8H190.3V215.8Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.2 72.9L169.2 78.9H163.2V72.9Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M521.3 297L515.3 291H521.3V297Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M416.382 258.648V222.32L507.469 78.8182H538.79V129.102H520.253L462.831 219.976V221.68H592.27V258.648H416.382ZM521.105 297V247.568L521.957 231.482V78.8182H565.21V297H521.105Z",
    fill: "#006BD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.382 252.648V216.32L501.469 72.8182H532.79V123.102H514.253L456.831 213.976V215.68H586.27V252.648H410.382ZM515.105 291V241.568L515.957 225.482V72.8182H559.21V291H515.105Z",
    fill: "#007FFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M416.5 258.6L410.5 252.6H416.5V258.6Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M586.3 215.8L592.3 221.8H586.3V215.8Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M559.2 72.9L565.2 78.9H559.2V72.9Z",
    fill: "#006BD5",
    stroke: "#006BD5",
    strokeWidth: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.232 298.794C289.908 298.723 274.141 294.213 260.93 285.264C247.791 276.315 237.67 263.354 230.568 246.379C223.537 229.405 220.057 208.986 220.128 185.122C220.128 161.33 223.643 141.053 230.675 124.291C237.777 107.53 247.898 94.7812 261.037 86.0455C274.247 77.2386 289.979 72.8352 308.232 72.8352C326.484 72.8352 342.18 77.2386 355.32 86.0455C368.53 94.8523 378.686 107.636 385.788 124.398C392.891 141.088 396.406 161.33 396.335 185.122C396.335 209.057 392.784 229.511 385.682 246.486C378.651 263.46 368.565 276.422 355.426 285.371C342.287 294.32 326.555 298.794 308.232 298.794ZM308.232 260.548C320.732 260.548 330.71 254.263 338.168 241.692C345.625 229.121 349.318 210.264 349.247 185.122C349.247 168.574 347.543 154.795 344.134 143.787C340.795 132.778 336.037 124.504 329.858 118.964C323.75 113.425 316.541 110.655 308.232 110.655C295.803 110.655 285.859 116.869 278.402 129.298C270.945 141.727 267.18 160.335 267.109 185.122C267.109 201.884 268.778 215.875 272.116 227.097C275.526 238.247 280.32 246.628 286.499 252.239C292.678 257.778 299.922 260.548 308.232 260.548Z",
    fill: "#006BD5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300.232 298.794C281.908 298.723 266.141 294.213 252.93 285.264C239.791 276.315 229.67 263.354 222.568 246.379C215.537 229.405 212.057 208.986 212.128 185.122C212.128 161.33 215.643 141.053 222.675 124.291C229.777 107.53 239.898 94.7812 253.037 86.0455C266.247 77.2386 281.979 72.8352 300.232 72.8352C318.484 72.8352 334.18 77.2386 347.32 86.0455C360.53 94.8523 370.686 107.636 377.788 124.398C384.891 141.088 388.406 161.33 388.335 185.122C388.335 209.057 384.784 229.511 377.682 246.486C370.651 263.46 360.565 276.422 347.426 285.371C334.287 294.32 318.555 298.794 300.232 298.794ZM300.232 260.548C312.732 260.548 322.71 254.263 330.168 241.692C337.625 229.121 341.318 210.264 341.247 185.122C341.247 168.574 339.543 154.795 336.134 143.787C332.795 132.778 328.037 124.504 321.858 118.964C315.75 113.425 308.541 110.655 300.232 110.655C287.803 110.655 277.859 116.869 270.402 129.298C262.945 141.727 259.18 160.335 259.109 185.122C259.109 201.884 260.778 215.875 264.116 227.097C267.526 238.247 272.32 246.628 278.499 252.239C284.678 257.778 291.922 260.548 300.232 260.548Z",
    fill: "#007FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404PageNotFound);
export default __webpack_public_path__ + "static/media/404PageNotFound.783aa16fbbd49143e5b39e5cce85a28f.svg";
export { ForwardRef as ReactComponent };